export const IMPERSONATED_SESSION = 'impersonated_session';
export const REDIRECTION_SESSION = 'redirection_session';

export function getCookie(cookiesKey) {
    const res = document.cookie
        .split(';')
        .map((cookieString) => cookieString.trim().split('='))
        .reduce((acc, curr) => {
            acc[curr[0]] = curr[1];
            return acc;
        }, {});

    return res[cookiesKey] ? JSON.parse(res[cookiesKey]) : null;
}

export function setTopLevelDomainCookie({ name, value }: { name: string; value: string }) {
    const domain = window.location.hostname.split(/\./).slice(-2).join('.');
    document.cookie = `${name}=${value};domain=${domain};path=/`;
}

export function deleteCookie(name: string) {
    const domain = window.location.hostname.split(/\./).slice(-2).join('.');

    document.cookie = `${name}=;expires=${new Date().toUTCString()};domain=${domain};path=/`;
}
